export default function InputPassword() {
    return {
        restrict: "E",
        scope: {
            form: "=",
            user: "=",
            validation: "=",
            required: "=",
            label: "=",
        },
        template: require("./input-password.html"),

        controller: function ($scope, PasswordReqEx) {
            $scope.passwordReqEx = PasswordReqEx;

            $scope.stringOfIllegalChars = "";
        },
    };
}
